module.exports = __webpack_public_path__ + "static/media/threeUp-business-personal-property.8a4a18e0.png";